export default __webpack_public_path__ + "static/media/gallery16.b20454a2.jpg";